import {
  createEntityAdapter,
  createSelector,
  createSlice,
  PayloadAction,
} from '@reduxjs/toolkit'
import { State } from '../../types/StateType'
import { SinglePatientAlertType } from './types'

const singlePatientAlertAdapter = createEntityAdapter<SinglePatientAlertType>({
  selectId: (alert) => alert.key,
})

let definedProps: { error: any; loading: boolean; success: any } = {
  error: null,
  loading: false,
  success: null,
}

const initialState = singlePatientAlertAdapter.getInitialState(definedProps)

const singlePatientAlertSlice = createSlice({
  name: 'singlePatientAlert',
  initialState: initialState,
  reducers: {
    getSinglePatientAlert: (state, action: PayloadAction<string>) => {
      state.loading = true
    },
    addSinglePatientAlert: (
      state,
      action: PayloadAction<SinglePatientAlertType>
    ) => {
      state.loading = false
      singlePatientAlertAdapter.upsertOne(state, action.payload)
    },
    errorSinglePatientAlert: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload
    },
  },
})

export const {
  addSinglePatientAlert,
  errorSinglePatientAlert,
  getSinglePatientAlert,
} = singlePatientAlertSlice.actions

export default singlePatientAlertSlice.reducer

const { selectById } = singlePatientAlertAdapter.getSelectors()

export const selectAllSinglePatientAlerts = createSelector(
  (state: State) => state.singlePatientAlertState,
  (singlePatientAlert) => Object.values(singlePatientAlert['entities'])
)

export const selectSinglePatientAlertsById = (id: string) =>
  createSelector(
    (state: State) => state.singlePatientAlertState,
    (singlePatientAlert) => selectById(singlePatientAlert, id)
  )
export const selectSingleAlertFromSinglePatientAlertsById = (
  id: string,
  alertId: string
) =>
  createSelector(
    (state: State) => state.singlePatientAlertState,
    (singlePatientAlert) =>
      selectById(singlePatientAlert, id)?.patientAlertData.find(
        (alert) => alert.alertId === alertId
      )
  )

export const selectErrorInSinglePatientAlertsScore = createSelector(
  (state: State) => state.singlePatientAlertState.error,
  (error) => error
)
export const selectSuccessInSingleAlertsMewsScore = createSelector(
  (state: State) => state.singlePatientAlertState.success,
  (success) => success
)
